import {
  makeStyles,
  Theme,
  useTheme,
  withStyles,
} from "@material-ui/core/styles";
import {
  Button,
  IconButton,
  LightColors,
  Menu,
  MobileMenu,
  Modal,
  RadioButton,
  Typography,
  WebMenuItem,
} from "@thingsw/pitta-design-system";
import clsx from "clsx";
import React, {
  createRef,
  RefObject,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Drawer from "@material-ui/core/Drawer";

import {
  CAMERA,
  ICameraInfo,
  loadFirmwareSettings,
  // loadMultiCamLocation,
  // loadMyCemrasLocation,
  // loadPublicCameraLocation,
  TabNameInfo1,
} from "../../features/Camera/slice";
import { RootState } from "../../features/store";
import { LiveViewPlayer } from "./LiveViewPlayer";

import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import CheckIcon from "@material-ui/icons/Check";
import Switch from "@material-ui/core/Switch";
import CloseIcon from "@material-ui/icons/Close";
import ErrorIcon from "@material-ui/icons/Error";

import Input from "@thingsw/pitta-design-system/dist/components/Input";
import SearchIcon from "@material-ui/icons/Search";
import _ from "lodash";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import update from "immutability-helper";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Webviewer } from "../../contants/Breakpoints";
import {
  Direction,
  Front,
  Rear,
  Interior,
  Option,
  IGPSLocation,
  GPSMessage,
} from "../../types";
import { getDirection } from "../../utils/VOD";
import { LocationMap } from "../maps/LocationMap";
import {
  MODELS_2CH,
  MODELS_3CH,
  OPTION_CAMERA_MODELS,
} from "../../contants/Models";
import { PERMISSION } from "../../features/Permission/slice";
import { useHistory, useLocation } from "react-router-dom";
import { loadUsageInfo, USER } from "../../features/User/slice";
import { PAYMENT } from "../../features/Payment/slice";
import { EmptyItems } from "../EmptyItems";
import MicToggle from "../MicToggle";
import { finishLiveview, LIVEVIEW } from "../../features/LiveView/slice";
import { detect } from "detect-browser";
import { useQuery } from "../../hooks/useQuery";
import { getFirmwareConfig } from "../../utils/Firmware";
import { setExitFullscreen } from "../../features/Theme/slice";
import { LOCATION_WS } from "../../features/LocationWS/slice";
import { jwtAxiosInst } from "../../utils";
import { LiveViewExceedModal } from "../modals/LiveViewExceedModal";
import { PricingModal } from "../modals/PricingModal";
import { exceedLiveview } from "../../utils/App";

const StyledSwitch = withStyles(() => ({
  root: {
    width: 48,
    height: 30,
    padding: 4,
  },
  switchBase: {
    padding: 6,
    "&.Mui-checked": {
      transform: "translateX(18px)",
    },
  },
  thumb: {
    width: 18,
    height: 18,
  },
  track: {
    backgroundColor: LightColors.primary["4"],
    borderRadius: 11,
  },
  colorPrimary: {
    "&.Mui-checked": {
      color: LightColors.primary["0"],
    },
    "&.Mui-checked + .MuiSwitch-track": {
      backgroundColor: LightColors.primary["7"],
      opacity: 1,
    },
  },
}))(Switch);

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    // padding: theme.spacing(3, 0, 0),
    padding: (props: LiveViewPanelProps) => {
      if (props.app) {
        return 0;
      }
      if (props.notification) {
        return theme.spacing(2, 0, 0);
      }
      return theme.spacing(3, 0, 0);
    },
    display: "flex",
    flexDirection: "column",
    flex: 1,
    [theme.breakpoints.up(Webviewer.mobile)]: {
      margin: theme.spacing(0, 4, 2, 4),
    },
    height: "100%",
  },
  menuDiv: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: LightColors.primary["1"],
    color: LightColors.primary["0"],
    padding: theme.spacing(1.125, 1),
    // "& svg": {
    //   fill: LightColors.primary["0"],
    // },
    borderBottom: `1px solid ${LightColors.primary["0"]}`,
  },
  dirDiv: {
    display: "flex",
    alignItems: "center",
    // width: 62,
    cursor: "pointer",
    [theme.breakpoints.up(Webviewer.mobile)]: {
      marginRight: 5.5,
    },
  },
  mapDiv: {
    // mantis - 9260, safari / chrome 지도안보이는 이슈 수정 (Leehj)
    height: 188,
    minHeight: 188,
    position: "relative",
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
    flex: "1 1 auto",
  },

  // mantis - 9108, notification -> liveView버튼을 통해 열리는 모달 내의 지도 높이 수정(Leehj)
  mapDivNotification: {
    height: 259,
    [theme.breakpoints.up(Webviewer.mobile)]: {
      height: 444,
    },
  },
  mapDivApp: {
    // app에서 스크롤 생겨서 지도크기 조절 (HJ)
    height: "calc(100vh - 122vw)",
    marginTop: theme.spacing(1),
  },
  mapDivAppNoBottom: {
    marginBottom: 0,
  },
  uncheckedMenu: {
    paddingLeft: 44,
  },
  multiViewTextDiv: {
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(1),
  },
  liveViewDiv: {
    cursor: "pointer",
    width: "calc(50% - 0.5px)",
    "&:nth-child(odd)": {
      marginRight: 1,
    },
    marginBottom: 1,
  },
  selectedLiveviewDiv: {
    border: `3px solid ${LightColors.secondary["17"]}`,
  },
  sLiveViewDiv: {
    width: "100%",
    margin: "0!important",
  },
  multiViewDiv: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  cameraDrawerDiv: {
    width: 469,
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  iconBtn: {
    padding: 0,
  },
  drawerHeaderDiv: {
    padding: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: `1px solid ${LightColors.primary["6"]}`,
  },
  cameraDiv: {
    flex: 1,
    padding: theme.spacing(2, 3),
  },
  drawerBtnDiv: {
    height: 68,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    borderTop: `1px solid ${LightColors.primary["6"]}`,
    padding: theme.spacing(2),
  },
  cancelBtn: {
    marginRight: theme.spacing(2),
  },
  searchIcon: {
    "& svg": {
      fontSize: "1rem!important",
    },
  },
  camListDiv: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1.375),
  },
  camListItem: {
    display: "flex",
    flexDirection: "column",
    marginBottom: theme.spacing(2),
  },
  camName: {
    marginLeft: theme.spacing(0.5),
  },
  modelName: {
    marginLeft: theme.spacing(4.5),
    marginTop: theme.spacing(-1),
  },
  videoTitleDiv: {
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    maxWidth: "60vw",
    // mantis 10100 - iPhone SE에서 Liveview의 카메라 방향 버튼 우측이 잘려서 출력되는 이슈 수정(Leehj)
    [theme.breakpoints.down(360)]: {
      maxWidth: "54vw",
    },
  },
  micToggleDiv: {
    marginRight: 18,
    // mantis 10100 - iPhone SE에서 Liveview의 카메라 방향 버튼 우측이 잘려서 출력되는 이슈 수정(Leehj)
    [theme.breakpoints.down(360)]: {
      marginRight: 6,
    },
  },
  mobileMemuItem: {
    padding: theme.spacing(1.5, 2),
  },
  noGpsDiv: {
    position: "absolute",
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "rgba(19, 19, 28, 0.45)",
  },
  modalTitle: {
    minHeight: 16,
  },
  emptyDiv: {
    marginTop: "6.75vh",
    [theme.breakpoints.up(Webviewer.mobile)]: {
      marginTop: "27.7vh",
    },
  },
  noCamText: {
    marginTop: theme.spacing(1.125),
  },
  disabled: {
    color: `${LightColors.primary["0"]}40`,
    fill: `${LightColors.primary["0"]}40`,
  },
  ctrlIcon: {
    padding: 0,
    marginRight: theme.spacing(1),
    color: LightColors.primary["0"],
    fill: LightColors.primary["0"],
    "&>svg": {
      color: LightColors.primary["0"],
      fill: LightColors.primary["0"],
    },
    "&.Mui-disabled": {
      color: `${LightColors.primary["0"]}40`,
      fill: `${LightColors.primary["0"]}40`,
    },
  },
  videoDiv: {
    width: "100%",
    position: "relative",
    overflow: "hidden",
    backgroundColor: LightColors.primary["1"],
    paddingTop:
      "max(350px, calc(100vh - 108px - 188px - 24px - 24px - 49px - 16px))",
  },
  videoDivApp: {
    paddingTop: "75vw",
  },
  hide: {
    display: "none",
  },
  iosModalContent: {
    paddingTop: 32,
  },
}));

export interface LiveViewPanelProps {
  camera: ICameraInfo;
  isEvent?: boolean;
  isPublic?: boolean;
  dir?: Direction;
  notification?: boolean;
  app?: boolean;
  ignoreRemove?: boolean;
  onBack?: (reason?: string) => void;
  modal?: boolean;
  speedUnit?: "0" | "1";
  noBottom?: boolean;
}

export const LiveViewPanel = (props: LiveViewPanelProps) => {
  const {
    camera,
    dir,
    isEvent,
    isPublic,
    app,
    ignoreRemove,
    notification,
    onBack,
    modal,
    speedUnit,
    noBottom,
  } = props;
  const classes = useStyles(props);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation<{ clicked?: boolean }>();
  const theme = useTheme();
  const query = useQuery();
  const mobile = useMediaQuery(theme.breakpoints.down(Webviewer.mobile));

  const updateCenter = useRef<boolean>(false);
  const prevPSNRef = useRef<string | undefined>(undefined);
  const cancelRequestedRef = useRef(false);

  const menusRef = useRef<RefObject<HTMLDivElement>[]>([
    createRef<HTMLDivElement>(),
    createRef<HTMLDivElement>(),
    createRef<HTMLDivElement>(),
    createRef<HTMLDivElement>(),
    createRef<HTMLDivElement>(),
  ]);
  const [menuAnchorRef, setMenuAnchorRef] = useState<RefObject<HTMLDivElement>>(
    menusRef.current[4]
  );

  const { gpsWS, gpsWsReadyState } = useSelector(
    (state: RootState) => state[LOCATION_WS]
  );
  const { permission } = useSelector((state: RootState) => state[PERMISSION]);
  const { subscriptionInfo } = useSelector(
    (state: RootState) => state[PAYMENT]
  );

  const { cameraList, publicCams, firmware } = useSelector(
    (state: RootState) => state[CAMERA]
  );

  const { usageInfo, email, tokenType, userProfile } = useSelector(
    (state: RootState) => state[USER]
  );
  const { removePlayer, reason } = useSelector(
    (state: RootState) => state[LIVEVIEW]
  );

  const videoSettings = useMemo(() => {
    return _.find(firmware?.cloud_settings, (c) => c.section_name === "Tab1")
      ?.section_info as TabNameInfo1;
  }, [firmware?.cloud_settings]);

  const [openMenu, setOpenMenu] = useState(false);
  const [openCameraMenu, setOpenCameraMenu] = useState(false);
  const [multiview, setMultiview] = useState(false);
  const [firmwareConfig, setFirmwareConfig] = useState<IFirmwareConfig>();
  const [cameras, setCameras] = useState<(ICameraInfo | undefined)[]>([
    camera,
    undefined,
    undefined,
    undefined,
  ]);
  const [directions, setDirections] = useState<(Direction | undefined)[]>([
    dir,
    undefined,
    undefined,
    undefined,
  ]);
  const [viewIndx, setViewIndx] = useState<number>();
  const [addedCam, setAddedCam] = useState<string>();
  const [, setMap] = useState<any>();
  const [locations, setLocations] = useState<IGPSLocation[]>([]);
  const [currentCam, setCurrentCam] = useState<ICameraInfo>();
  const [selectedPSN, setSelectedPSN] = useState<string>();
  const [center, setCenter] = useState<{ lat: number; lng: number }>();
  const [disableLiveview, setDisableLiveview] = useState(true);
  const [openLimitLiveview, setOpenLimitLiveview] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  // 7027 - 방향 전환 시, 5초간 방향전환 못하게 수정
  const [disableDir, setDisableDir] = useState(false);
  const loginInfo = useSelector((state: RootState) => state[USER].loginInfo);
  const [enableMic, setEnableMic] = useState<boolean[]>([
    false,
    false,
    false,
    false,
  ]);
  // 1: 권한 있음, 0: 권한 없음, 2: 권한 없고 팝업 띄우지 말것 (iOS시나리오)
  const [micPerm, setMicPerm] = useState<number>(1);
  const [openNoMicPermModal, setOpenNoMicPermModal] = useState(false);
  const [openNoMicPermIOSModal, setOpenNoMicPermIOSModal] = useState(false);
  const [disconnected, setDisconnected] = useState(false);
  // const [isLandscape, setIsLandscape] = useState(false);
  const [audioLevel, setAudioLevel] = useState(0);
  const [micBtnDisabled, setMicBtnDisabled] = useState(false);
  const [twoWayInUse, setTwoWayInUse] = useState(false);
  const [playingPlayer1, setPlayingPlayer1] = useState(false);
  const [loadingTwoWay, setLoadingTwoWay] = useState(false);

  const [openPricing, setOpenPricing] = useState(false);

  const CLOUD_NATIVE = useMemo(() => {
    console.log(
      "CloudNative",
      "CLOUD_NATIVE",
      "firmwareConfig",
      firmwareConfig,
      "!!firmwareConfig?.CloudNative",
      !!firmwareConfig?.CloudNative
    );
    if (firmwareConfig === undefined) {
      return undefined;
    }
    return !!firmwareConfig?.CloudNative;
  }, [firmwareConfig]);

  // 7027 - 방향 전환 시, 5초간 방향전환 못하게 수정
  useEffect(() => {
    if (disableDir) {
      const timerId = setTimeout(() => {
        setDisableDir(false);
      }, 5000);
      return () => {
        clearTimeout(timerId);
      };
    }
  }, [disableDir]);

  useEffect(() => {
    if (currentCam?.psn) {
      dispatch(loadFirmwareSettings(currentCam.psn));
    }
  }, [currentCam?.psn, dispatch]);

  // 안드로이드에서 back버튼 클릭시, 뷰어를 바로 닫아버림
  // 이로인해, effect hook의 정리 루틴이 정상적으로 실행되지 않아서,
  // webrtc live view 종료가 되지 않는 문제가 발생
  // 안드로이드에서 backpress 이벤트를 받아서, player를 없애고,
  // 가짜 화면을 잠시 나오게 하면서, effect hook의 정리 루틴이 실행될 시간을 만들어줌
  //@ts-ignore
  window.backPressed = window.onBackground = useCallback(() => {
    if (app && !removePlayer) {
      console.log("CloudNative", "window.backPressed");
      dispatch(finishLiveview());
    }
  }, [app, dispatch, removePlayer]);

  useEffect(() => {
    if (camera) {
      const config = getFirmwareConfig(camera);
      setFirmwareConfig(config);
    }
  }, [camera]);

  useEffect(() => {
    // 플레이어 종료시, mic 아이콘 off상태로 변경
    if (removePlayer) {
      setEnableMic([false, false, false, false]);
    }
  }, [removePlayer]);

  useEffect(() => {
    const mic_perm = query.get("mic_perm");
    if (mic_perm) {
      setMicPerm(parseInt(mic_perm));
    }
  }, [query]);

  useEffect(() => {
    if (twoWayInUse) {
      const timer = setTimeout(() => {
        setTwoWayInUse(false);
      }, 2000);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [twoWayInUse]);

  // useEffect(() => {
  //   if (app) {
  //     const listener = (e) => {
  //       console.log(
  //         "CloudNative",
  //         "isLandscape",
  //         e.target.innerWidth > e.target.innerHeight
  //       );
  //       setIsLandscape(e.target.innerWidth > e.target.innerHeight);
  //     };
  //     window.addEventListener("orientationchange", listener);

  //     return () => {
  //       window.removeEventListener("orientationchange", listener);
  //     };
  //   }
  // }, [app]);

  useEffect(() => {
    if (app) {
      const cam = _.find(
        cameraList?.deviceListInfo,
        (d) => d.device.psn === currentCam?.psn
      );
      if (cam?.device.active === "off") {
        console.log(
          "CloudNative",
          "request finish liveview due to disconnected dashcam"
        );
        dispatch(finishLiveview());
        setDisconnected(true);
        console.log("cam off");
      }
    }
  }, [app, cameraList?.deviceListInfo, currentCam?.psn, dispatch]);

  useEffect(() => {
    // refresh될 경우 clicked flag 삭제
    window.onbeforeunload = (e: any) => {
      history.replace(location.pathname);
    };
  }, [history, location.pathname]);

  useEffect(() => {
    if (subscriptionInfo?.servicePlanName === "free") {
      if (usageInfo && usageInfo.liveViewDayUsage < usageInfo.LimitLiveView) {
        setDisableLiveview(false);
      } else if (
        usageInfo &&
        usageInfo.liveViewDayUsage >= usageInfo.LimitLiveView
      ) {
        if (app) {
          // 10861 - 라이브뷰 사용량 초과시 앱으로 메시지 전달 (mckim)
          exceedLiveview();
        } else {
          setOpenLimitLiveview(true);
        }
      }
    } else if (subscriptionInfo) {
      setDisableLiveview(false);
    }
  }, [usageInfo, subscriptionInfo, app]);

  useEffect(() => {
    if (loginInfo?.userType === "Etc") {
      dispatch(loadUsageInfo());
    }
    // dispatch(loadCameras());
  }, [dispatch, loginInfo?.userType]);

  useEffect(() => {
    if (!permission.liveviewPerm) {
      history.goBack();
    }
  }, [history, permission.liveviewPerm]);

  useEffect(() => {
    setCurrentCam(camera);
    setSelectedPSN(camera.psn);
    prevPSNRef.current = camera.psn;
  }, [camera]);

  useEffect(() => {
    if (mobile) {
      setMultiview(false);
    }
  }, [mobile]);

  useEffect(() => {
    if (email && gpsWsReadyState === WebSocket.OPEN) {
      // public cam일경우 위치 요청 API 수정 (7143)
      if (isPublic) {
        // dispatch(loadPublicCameraLocation({ psn: camera.psn, cancel }));

        const msg: GPSMessage = {
          action: "gpsPsnsSpecificDevice",
          email,
          psn: camera?.psn,
          sequenceId: new Date().getTime(),
        };
        gpsWS?.send(JSON.stringify(msg));
      } else if (permission.multiLiveviewPerm /*|| !app*/) {
        // dispatch(
        //   loadMultiCamLocation({
        //     psns: _.compact([
        //       camera?.psn,
        //       ..._.chain(cameras)
        //         .map((cam) => cam?.psn)
        //         .value(),
        //     ]),
        //     cancel,
        //   })
        // );

        const msg: GPSMessage = {
          action: "gpsPsnsMultiLiveView",
          email,
          psns: _.chain([
            camera?.psn,
            ..._.chain(cameras)
              .map((cam) => cam?.psn)
              .value(),
          ])
            .compact()
            .uniq()
            .value(),
          sequenceId: new Date().getTime(),
        };
        gpsWS?.send(JSON.stringify(msg));
      } else {
        // GPS WS 생성 시, 내 디바이스 위치가 있는지 확인
        const msg: GPSMessage = {
          action: "gpsPsnsMyDevices",
          email,
          sequenceId: new Date().getTime(),
        };
        gpsWS?.send(JSON.stringify(msg));
        // dispatch(loadMyCemrasLocation({ cancel }));
      }
    }
  }, [
    dispatch,
    camera,
    cameras,
    permission.multiLiveviewPerm,
    isPublic,
    app,
    email,
    gpsWsReadyState,
    gpsWS,
  ]);

  useEffect(() => {
    const locs: IGPSLocation[] = [];
    if (cameraList) {
      const psns = [camera?.psn, ..._.map(cameras, (c) => c?.psn)];
      const cams = _.filter(cameraList.deviceListInfo, (c) =>
        _.includes(psns, c.device.psn)
      );
      console.log(
        "CloudNative3",
        "LiveViewPanel",
        "psns",
        psns,
        "cams",
        cams,
        "publicCams",
        publicCams
      );
      for (const cam of cams) {
        const device = cam.device;
        if (
          device.latitude &&
          device.longitude &&
          (device.agree_gps === "on" || app)
        ) {
          const lat = parseFloat(device.latitude);
          const lng = parseFloat(device.longitude);
          locs.push({
            lat,
            lng,
            heading: device.dir_angle
              ? parseFloat(device.dir_angle)
              : undefined,
            psn: device.psn,
            name: device.dev_name,
            speed: device.speed,
            mode: device.mode,
            model: device.model,
            active: device.active,
            agree_gps: device.agree_gps,
            isPublic: false,
          });
          if (
            device.psn === selectedPSN &&
            (updateCenter.current || !multiview)
          ) {
            // 멀티 라이브뷰 상태일때만 1회 위치 변경
            if (multiview) {
              updateCenter.current = false;
            }
            setCenter({ lat, lng });
          }
        }
      }
    }

    const found = _.find(publicCams, (cam) => cam.psn === camera.psn);
    if (found) {
      const { lat, lng } = found;
      locs.push({
        lat: found.lat,
        lng: found.lng,
        // mantis - 10315, 카메라의 Live view 진입 시 heading이 0으로 출력되어 지도 위 카메라 방향이 비정상적으로 출력 되는 이슈 수정 (Leehj)
        heading:
          camera.share_gps === "on" && found.dir_angle
            ? parseFloat(found.dir_angle)
            : undefined,
        psn: found.psn,
        name: camera.share_dev_name === "on" ? found.dev_name : undefined,
        speed: found.speed,
        mode: found.mode,
        active: found.active,
        share_video: found.share_video,
        profile_img: found.profile_img,
        isPublic: true,
      });
      setCenter({ lat, lng });
    }

    console.log("CloudNative3", "LiveViewPanel", "locs", locs);

    setLocations(locs);
  }, [
    app,
    camera.psn,
    camera.share_dev_name,
    camera.share_gps,
    cameraList,
    cameras,
    multiview,
    publicCams,
    selectedPSN,
  ]);

  //Blackvue7 Box 옵션 카메라 방향 추가 (8460)
  const isOptionModel = useMemo(
    () => _.includes(OPTION_CAMERA_MODELS, camera?.model),
    [camera?.model]
  );

  const setCamDirection = useCallback(
    (dir: Direction) => {
      let indx = _.findIndex(cameras, (dev) => dev?.psn === currentCam?.psn);

      setOpenMenu(false);
      if (indx > -1) {
        setDirections((d) => {
          d[indx] = dir;
          return [...d];
        });
      }
      if (dir !== directions[indx]) {
        setDisableDir(true);
      }
    },
    [cameras, currentCam?.psn, directions]
  );

  const directionMenuMarkup = useMemo(() => {
    let indx = _.findIndex(cameras, (dev) => dev?.psn === currentCam?.psn);
    const dir = directions[indx] ?? 1;

    //Blackvue7 Box 옵션 카메라 방향 추가 (8460)
    let direction3rd: JSX.Element | undefined = undefined;
    if (_.includes(MODELS_3CH, camera.model)) {
      if (isOptionModel) {
        direction3rd = (
          <WebMenuItem
            key="direction-option"
            startIcon={
              !mobile && dir === Option && <CheckIcon fontSize="small" />
            }
            endIcon={mobile && dir === Option && <CheckIcon fontSize="small" />}
            className={clsx({
              [classes.uncheckedMenu]: dir !== Option && !mobile,
              [classes.mobileMemuItem]: mobile,
            })}
            onClick={() => setCamDirection(Option)}
          >
            {t("Option")}
          </WebMenuItem>
        );
      } else {
        direction3rd = (
          <WebMenuItem
            key="direction-interior"
            startIcon={
              !mobile && dir === Interior && <CheckIcon fontSize="small" />
            }
            endIcon={
              mobile && dir === Interior && <CheckIcon fontSize="small" />
            }
            className={clsx({
              [classes.uncheckedMenu]: dir !== Interior && !mobile,
              [classes.mobileMemuItem]: mobile,
            })}
            onClick={() => setCamDirection(Interior)}
          >
            {t("Interior")}
          </WebMenuItem>
        );
      }
    }

    return _.compact([
      <WebMenuItem
        key="direction-front"
        startIcon={!mobile && dir === Front && <CheckIcon fontSize="small" />}
        endIcon={mobile && dir === Front && <CheckIcon fontSize="small" />}
        className={clsx({
          [classes.uncheckedMenu]: dir !== Front && !mobile,
          [classes.mobileMemuItem]: mobile,
        })}
        onClick={() => setCamDirection(Front)}
      >
        {t("Front")}
      </WebMenuItem>,
      _.includes([...MODELS_2CH, ...MODELS_3CH], currentCam?.model) && (
        <WebMenuItem
          key="direction-rear"
          startIcon={!mobile && dir === Rear && <CheckIcon fontSize="small" />}
          endIcon={mobile && dir === Rear && <CheckIcon fontSize="small" />}
          className={clsx({
            [classes.uncheckedMenu]: dir !== Rear && !mobile,
            [classes.mobileMemuItem]: mobile,
          })}
          onClick={() => setCamDirection(Rear)}
        >
          {t("Rear")}
        </WebMenuItem>
      ),
      direction3rd,
    ]);
  }, [
    camera.model,
    cameras,
    classes.mobileMemuItem,
    classes.uncheckedMenu,
    currentCam?.model,
    currentCam?.psn,
    directions,
    isOptionModel,
    mobile,
    setCamDirection,
    t,
  ]);

  const handleChannelChange = useCallback(
    (indx: number) => (dir: Direction, failed?: boolean) => {
      console.log("CloudNative", "handleChannelChange", dir, failed);
      if (failed) {
        setDisableDir(false);
      }
      setDirections((d) => {
        d[indx] = dir;
        return [...d];
      });
    },
    []
  );

  const stopVoiceCall = useCallback(
    async (enabledIndx: number) => {
      cancelRequestedRef.current = true;
      setLoadingTwoWay(true);
      let cam = cameras[enabledIndx];
      if (cam) {
        await jwtAxiosInst.post(`/IoT/devicecommand`, {
          command: "TwoWayStop",
          email,
          user_token: loginInfo?.user_token,
          tokenType: tokenType,
          psn: cam.psn,
        });
        setEnableMic((e) => {
          e[enabledIndx] = false;
          return [...e];
        });
      }
      setLoadingTwoWay(false);
      cancelRequestedRef.current = false;
    },
    [cameras, email, loginInfo?.user_token, tokenType]
  );

  useEffect(() => {
    const camIndx = _.findIndex(cameras, (c) => c?.psn === selectedPSN);
    const enabledIndx = _.findIndex(enableMic, (e) => e);
    console.log("CloudNative", camIndx, enabledIndx);
    if (enabledIndx > -1 && camIndx !== enabledIndx) {
      stopVoiceCall(enabledIndx);
    }
  }, [cameras, enableMic, selectedPSN, stopVoiceCall]);

  // 클라우드 네이티브 two way voice command api 처리
  const toggleMic = useCallback(
    (index: number) => async () => {
      console.log(
        "CloudNative",
        "toggleMic",
        "index",
        index,
        "micPerm",
        micPerm
      );
      if (index > -1) {
        if (micPerm === 0) {
          const browser = detect();
          dispatch(setExitFullscreen({}));
          if (browser?.name === "ios-webview") {
            //@ts-ignore
            return webkit.messageHandlers.alert.postMessage({
              reason: "NO_MIC_PERMISSION",
            });
          } else if (browser?.name === "chromium-webview") {
            //@ts-ignore
            return window.Webviewer?.alert(
              JSON.stringify({ reason: "NO_MIC_PERMISSION" })
            );
          } else {
            setOpenNoMicPermModal(true);
          }

          return;
        } else if (micPerm === 2) {
          setOpenNoMicPermIOSModal(true);
          dispatch(setExitFullscreen({}));
          return;
        }
      }

      try {
        setLoadingTwoWay(true);
        setMicBtnDisabled(true);

        if (index > -1) {
          let enabledCam = cameras[index];
          let enabled = enableMic[index];
          console.log(
            "CloudNative",
            "enabledCam",
            enabledCam,
            "enabled",
            enabled
          );
          if (!enabledCam) return;

          if (enabled) {
            if (!cancelRequestedRef.current) {
              cancelRequestedRef.current = true;

              await jwtAxiosInst.post(`/IoT/devicecommand`, {
                command: "TwoWayStop",
                email,
                user_token: loginInfo?.user_token,
                tokenType: tokenType,
                psn: enabledCam.psn,
              });

              setEnableMic((e) => {
                e[index] = false;
                return [...e];
              });
              cancelRequestedRef.current = false;
            }
          } else {
            prevPSNRef.current = enabledCam.psn;
            console.log("CloudNative", "PSN", "Start", prevPSNRef.current);
            const resp = await jwtAxiosInst.post(`/IoT/devicecommand`, {
              command: "TwoWayStart",
              email,
              user_token: loginInfo?.user_token,
              tokenType: tokenType,
              psn: enabledCam.psn,
            });
            let data: any;
            if (typeof resp.data === "string") {
              data = JSON.parse(resp.data);
            } else {
              data = resp.data;
            }

            if (data.resultcode === "BC_ERR_OK") {
              const status = data.status;
              if (status === "busy") {
                setTwoWayInUse(true);
              }
              setEnableMic((e) => {
                e[index] = status === "free";
                return [...e];
              });
            }
          }
        } else {
          prevPSNRef.current = selectedPSN;
        }
      } finally {
        // twoway 버튼 클릭 후, api응답 받으면 2초후 버튼 활성화
        setTimeout(() => {
          setMicBtnDisabled(false);
        }, 2000);

        setLoadingTwoWay(false);
      }
    },
    [
      cameras,
      dispatch,
      email,
      enableMic,
      loginInfo?.user_token,
      micPerm,
      selectedPSN,
      tokenType,
    ]
  );

  useEffect(() => {
    if (micPerm !== 1) {
      const enabledIndx = _.findIndex(enableMic, (e) => e);
      stopVoiceCall(enabledIndx);
    }
  }, [enableMic, micPerm, stopVoiceCall]);

  const handleNoMicPerm = useCallback((ignore?: boolean) => {
    setMicPerm((p) => {
      if (p === 1) {
        return ignore ? 2 : 0;
      }
      return p;
    });
  }, []);

  useEffect(() => {
    console.log(
      "CloudNative",
      "PSN",
      prevPSNRef.current,
      selectedPSN,
      cancelRequestedRef.current
    );
    if (
      selectedPSN &&
      prevPSNRef.current !== selectedPSN &&
      !cancelRequestedRef.current
    ) {
      toggleMic(-1)();
    }
  }, [selectedPSN, toggleMic]);

  useEffect(() => {
    // iOS 13 버전에서 navigator.mediaDevices가 undefined인 경우 수정
    if (navigator?.mediaDevices) {
      navigator.mediaDevices.ondevicechange = async (event) => {
        console.log("CloudNative", "ondevicechange");
        const devices = await navigator.mediaDevices.enumerateDevices();
        for (const device of devices) {
          if (device.kind === "audioinput") {
            console.log("CloudNative", "find new audio input", device);
            setMicPerm(1);
            break;
          }
        }
      };
      return () => {
        navigator.mediaDevices.ondevicechange = null;
      };
    }
  }, []);

  const handleChannelChange1 = useMemo(
    () => handleChannelChange(0),
    [handleChannelChange]
  );

  const handleChannelChange2 = useMemo(
    () => handleChannelChange(1),
    [handleChannelChange]
  );

  const handleChannelChange3 = useMemo(
    () => handleChannelChange(2),
    [handleChannelChange]
  );

  const handleChannelChange4 = useMemo(
    () => handleChannelChange(3),
    [handleChannelChange]
  );

  const playerMarkup1 = useMemo(() => {
    // console.log(
    //   "CloudNative",
    //   "playerMarkup1",
    //   "removePlayer",
    //   removePlayer,
    //   "ignoreRemove",
    //   ignoreRemove,
    //   "micBtnDisabled",
    //   micBtnDisabled
    // );
    return removePlayer && !ignoreRemove ? (
      <LiveViewPlayer
        camera={undefined}
        clicked={location.state?.clicked}
        direction={directions[0]}
        main
        disabled
        multiView={multiview}
        onChannelChange={handleChannelChange1}
        app={app}
        modal={modal}
      />
    ) : (
      <LiveViewPlayer
        camera={cameras[0]}
        isPublic={isPublic}
        clicked={location.state?.clicked}
        main
        disabled={disableLiveview}
        multiView={multiview}
        selected={selectedPSN === cameras[0]?.psn}
        direction={directions[0]}
        onChangePlaying={setPlayingPlayer1}
        // landscape={isLandscape}
        menuAnchorRef={menusRef.current[0]}
        onMenuOpen={() => {
          // mantis - 10092, 카메라 방향 드롭박스가 open된 채로 전체화면을 나가면 전체화면이 아닐 때 출력되는 카메라 방향 드롭박스를 열어준다.
          //  방향메뉴의 위치가 상이해져서 setMenuAnchorRef(menusRef.current[0])는 주석처리 (Leehj)
          setOpenMenu((o) => !o);
          // setMenuAnchorRef(menusRef.current[0]);
          setCurrentCam(cameras[0]);
        }}
        onChannelChange={handleChannelChange1}
        app={app}
        enableMic={enableMic[0]}
        onToggleMic={toggleMic(0)}
        onAudioLevelChanged={setAudioLevel}
        onNoMicPerm={handleNoMicPerm}
        micBtnDisabled={micBtnDisabled}
        twoWayInUse={twoWayInUse && selectedPSN === cameras[0]?.psn}
        modal={modal}
        loadingTwoWay={loadingTwoWay && selectedPSN === cameras[0]?.psn}
      />
    );
  }, [
    app,
    cameras,
    directions,
    disableLiveview,
    enableMic,
    handleChannelChange1,
    handleNoMicPerm,
    ignoreRemove,
    isPublic,
    loadingTwoWay,
    location.state?.clicked,
    micBtnDisabled,
    modal,
    multiview,
    removePlayer,
    selectedPSN,
    toggleMic,
    twoWayInUse,
  ]);

  // useEffect(() => {
  //   if (removePlayer) {
  //     setCameras([camera, undefined, undefined, undefined]);
  //   }
  // }, [camera, removePlayer]);

  useEffect(() => {
    console.log("CloudNative", "back", app, removePlayer);
    if (app && removePlayer) {
      console.log(
        "CloudNative",
        "onBack",
        disconnected ? "DEVICE_DISCONNECT" : reason
      );
      onBack?.(disconnected ? "DEVICE_DISCONNECT" : reason);
    }
  }, [app, removePlayer, onBack, disconnected, reason]);

  const playerMarkup2 = useMemo(() => {
    return removePlayer ? (
      <LiveViewPlayer
        camera={undefined}
        clicked={location.state?.clicked}
        direction={directions[1]}
        main
        disabled
        multiView={multiview}
        onChannelChange={handleChannelChange2}
        app={app}
      />
    ) : (
      <LiveViewPlayer
        camera={cameras[1]}
        disabled={disableLiveview}
        selected={selectedPSN === cameras[1]?.psn}
        onAddCamera={() => {
          setViewIndx(1);
          setOpenCameraMenu(true);
        }}
        onMenuOpen={() => {
          setMenuAnchorRef(menusRef.current[1]);
          setOpenMenu((o) => !o);
          setCurrentCam(cameras[1]);
        }}
        menuAnchorRef={menusRef.current[1]}
        multiView={multiview}
        direction={directions[1]}
        onClose={() => {
          cameras[1] = undefined;
          setCameras([...cameras]);
        }}
        onChannelChange={handleChannelChange2}
        enableMic={enableMic[1]}
        onToggleMic={toggleMic(1)}
        micBtnDisabled={micBtnDisabled}
        twoWayInUse={twoWayInUse && selectedPSN === cameras[1]?.psn}
        loadingTwoWay={loadingTwoWay && selectedPSN === cameras[1]?.psn}
      />
    );
  }, [
    app,
    cameras,
    directions,
    disableLiveview,
    enableMic,
    handleChannelChange2,
    loadingTwoWay,
    location.state?.clicked,
    micBtnDisabled,
    multiview,
    removePlayer,
    selectedPSN,
    toggleMic,
    twoWayInUse,
  ]);

  const playerMarkup3 = useMemo(() => {
    return removePlayer ? (
      <LiveViewPlayer
        camera={undefined}
        clicked={location.state?.clicked}
        direction={directions[2]}
        main
        disabled
        multiView={multiview}
        onChannelChange={handleChannelChange3}
        app={app}
      />
    ) : (
      <LiveViewPlayer
        camera={cameras[2]}
        disabled={disableLiveview}
        selected={selectedPSN === cameras[2]?.psn}
        onAddCamera={() => {
          setViewIndx(2);
          setOpenCameraMenu(true);
        }}
        onMenuOpen={() => {
          setMenuAnchorRef(menusRef.current[2]);
          setOpenMenu((o) => !o);
          setCurrentCam(cameras[2]);
        }}
        menuAnchorRef={menusRef.current[2]}
        multiView={multiview}
        direction={directions[2]}
        onClose={() => {
          cameras[2] = undefined;
          setCameras([...cameras]);
        }}
        onChannelChange={handleChannelChange3}
        enableMic={enableMic[2]}
        onToggleMic={toggleMic(2)}
        micBtnDisabled={micBtnDisabled}
        twoWayInUse={twoWayInUse && selectedPSN === cameras[2]?.psn}
        loadingTwoWay={loadingTwoWay && selectedPSN === cameras[2]?.psn}
      />
    );
  }, [
    app,
    cameras,
    directions,
    disableLiveview,
    enableMic,
    handleChannelChange3,
    loadingTwoWay,
    location.state?.clicked,
    micBtnDisabled,
    multiview,
    removePlayer,
    selectedPSN,
    toggleMic,
    twoWayInUse,
  ]);

  const playerMarkup4 = useMemo(() => {
    return removePlayer ? (
      <LiveViewPlayer
        camera={undefined}
        clicked={location.state?.clicked}
        direction={directions[3]}
        main
        disabled
        multiView={multiview}
        onChannelChange={handleChannelChange4}
        app={app}
      />
    ) : (
      <LiveViewPlayer
        camera={cameras[3]}
        disabled={disableLiveview}
        selected={selectedPSN === cameras[3]?.psn}
        onAddCamera={() => {
          setViewIndx(3);
          setOpenCameraMenu(true);
        }}
        onMenuOpen={() => {
          setMenuAnchorRef(menusRef.current[3]);
          setOpenMenu((o) => !o);
          setCurrentCam(cameras[3]);
        }}
        menuAnchorRef={menusRef.current[3]}
        multiView={multiview}
        direction={directions[3]}
        onClose={() => {
          cameras[3] = undefined;
          setCameras([...cameras]);
        }}
        onChannelChange={handleChannelChange4}
        enableMic={enableMic[3]}
        onToggleMic={toggleMic(3)}
        micBtnDisabled={micBtnDisabled}
        twoWayInUse={twoWayInUse && selectedPSN === cameras[3]?.psn}
        loadingTwoWay={loadingTwoWay && selectedPSN === cameras[3]?.psn}
      />
    );
  }, [
    app,
    cameras,
    directions,
    disableLiveview,
    enableMic,
    handleChannelChange4,
    loadingTwoWay,
    location.state?.clicked,
    micBtnDisabled,
    multiview,
    removePlayer,
    selectedPSN,
    toggleMic,
    twoWayInUse,
  ]);

  // const candidateCams = useMemo(() => {
  //   return _.chain(cameraList?.DeviceListInfo)
  //     .filter((cam) => cam.device.psn !== camera?.psn)
  //     .map((dev) => dev.device)
  //     .value();
  // }, [camera?.psn, cameraList?.DeviceListInfo]);

  const candidateCams = useMemo(() => {
    return _.chain(cameraList?.deviceListInfo)
      .filter(
        (cam) =>
          !_.chain(cameras)
            .map((c) => c?.psn)
            .includes(cam.device.psn)
            .value()
      )
      .value();
  }, [cameraList?.deviceListInfo, cameras]);

  const filteredCameras = useMemo(() => {
    return _.filter(
      candidateCams,
      (camera) =>
        camera.device.dev_name.toLowerCase().indexOf(searchKey.toLowerCase()) >
          -1 ||
        camera.device.model.toLowerCase().indexOf(searchKey.toLowerCase()) > -1
    );
  }, [candidateCams, searchKey]);

  return (
    <div className={classes.root}>
      <div style={{ flex: 1 }}>
        <div className={clsx(classes.menuDiv)}>
          <div style={{ display: "flex", alignItems: "center" }}>
            {!multiview ? (
              <Typography
                category="Default"
                variant="Body"
                className={clsx({ [classes.videoTitleDiv]: mobile })}
              >
                {/* maintis - 8459 , share_dev_name가 off이면서 공유된 카메라인 경우 'BLACKVUE'로 노출 */}
                {cameras[0] &&
                  (cameras[0].share_dev_name === "off" && isPublic
                    ? "BLACKVUE"
                    : `${cameras[0].dev_name} (${cameras[0].model})`)}
              </Typography>
            ) : (
              <div></div>
            )}
          </div>

          <div style={{ display: "flex", alignItems: "center" }}>
            {CLOUD_NATIVE &&
              !isPublic &&
              !multiview &&
              userProfile?.userType !== "User" && (
                <div className={classes.micToggleDiv}>
                  <MicToggle
                    enableMic={enableMic[0]}
                    volume={audioLevel}
                    onToggleMic={toggleMic(0)}
                    disabled={micBtnDisabled || !playingPlayer1}
                    loading={loadingTwoWay}
                  />
                </div>
              )}
            {!multiview && !isPublic && (
              // 7027 - 방향 전환 시, 5초간 방향전환 못하게 수정
              <div
                className={clsx(classes.dirDiv, {
                  [classes.disabled]: disableDir || !playingPlayer1,
                })}
                ref={menusRef.current[4]}
                onClick={() => {
                  if (!disableDir && playingPlayer1) {
                    setOpenMenu((o) => !o);
                  }
                }}
              >
                <Typography category="Default" variant="BodyBold">
                  {t(getDirection(directions[0] ?? 1, isOptionModel))}
                </Typography>
                <ExpandMoreIcon
                  fontSize="small"
                  style={{
                    fill: disableDir
                      ? `${LightColors.primary["0"]}40`
                      : undefined,
                  }}
                />
              </div>
            )}
            {!mobile &&
              !isEvent &&
              !isPublic &&
              permission.multiLiveviewPerm && (
                <>
                  <Typography
                    category="Default"
                    variant="BodyBold"
                    className={classes.multiViewTextDiv}
                  >
                    {t("Multi View")}
                  </Typography>
                  <StyledSwitch
                    color="primary"
                    checked={multiview}
                    onChange={(e, checked) => {
                      if (!checked) {
                        setMenuAnchorRef(menusRef.current[4]);
                        setCameras([camera, undefined, undefined, undefined]);
                        setDirections((d) => [
                          d[0],
                          undefined,
                          undefined,
                          undefined,
                        ]);
                        setEnableMic((e) => [e[0], false, false, false]);
                        setSelectedPSN(camera.psn);
                      }
                      setMultiview(checked);
                    }}
                  />
                </>
              )}
          </div>
        </div>
        <div className={classes.multiViewDiv}>
          <div
            className={clsx(classes.liveViewDiv, {
              [classes.sLiveViewDiv]: !multiview,
            })}
            onClick={() => {
              updateCenter.current = true;
              setSelectedPSN(cameras[0]?.psn);
            }}
          >
            {playerMarkup1}
          </div>
          {multiview && (
            <>
              <div
                className={clsx(classes.liveViewDiv)}
                onClick={() => {
                  updateCenter.current = true;
                  setSelectedPSN(cameras[1]?.psn);
                }}
              >
                {playerMarkup2}
              </div>
              <div
                className={clsx(classes.liveViewDiv)}
                onClick={() => {
                  updateCenter.current = true;
                  setSelectedPSN(cameras[2]?.psn);
                }}
              >
                {playerMarkup3}
              </div>
              <div
                className={clsx(classes.liveViewDiv)}
                onClick={() => {
                  updateCenter.current = true;
                  setSelectedPSN(cameras[3]?.psn);
                }}
              >
                {playerMarkup4}
              </div>
            </>
          )}
        </div>
      </div>
      <div
        className={clsx(classes.mapDiv, {
          // mantis - 9108, notification -> liveView버튼을 통해 열리는 모달 내의 지도 높이 수정(Leehj)
          [classes.mapDivNotification]: notification,
          [classes.mapDivApp]: app,
          [classes.mapDivAppNoBottom]: noBottom,
          // [classes.hide]: app && isLandscape,
        })}
      >
        {(videoSettings?.["UseGpsInfo"] === "1" || isPublic) && (
          <LocationMap
            disableAutoZoom
            onGoogleApiLoaded={({ map }) => {
              setMap(map);
            }}
            publicCams={publicCams}
            locations={locations}
            center={center}
            fullscreenIcon
            showHeading
            mode="liveview"
            app={app}
            speedUnit={speedUnit}
          />
        )}
        {videoSettings?.["UseGpsInfo"] === "0" && (
          <div className={classes.noGpsDiv}>
            <Typography
              category="Default"
              variant="BodyBold"
              htmlColor={LightColors.primary["0"]}
            >
              {t("GPS Location recording off")}
            </Typography>
          </div>
        )}
      </div>

      {mobile && !isPublic && (
        <MobileMenu open={openMenu} onClose={() => setOpenMenu(false)}>
          {directionMenuMarkup}
        </MobileMenu>
      )}
      {!mobile && !isPublic && (
        <Menu
          open={openMenu}
          anchorEl={menuAnchorRef.current}
          onClickAway={() => setOpenMenu(false)}
          placement="bottom-end"
        >
          {directionMenuMarkup}
        </Menu>
      )}
      <Drawer anchor={"right"} open={openCameraMenu}>
        <div className={classes.cameraDrawerDiv}>
          <div className={classes.drawerHeaderDiv}>
            <Typography category="Default" variant="H6">
              {t("Add camera to_")}
            </Typography>
            <IconButton
              className={classes.iconBtn}
              onClick={() => {
                setOpenCameraMenu(false);
                setSearchKey("");
              }}
            >
              <CloseIcon />
            </IconButton>
          </div>
          <div className={classes.cameraDiv}>
            <Input
              dense
              placeholder={t("search")}
              startIcon={<SearchIcon className={classes.searchIcon} />}
              onChange={(e) => setSearchKey(e.target.value)}
              value={searchKey}
              disabled={candidateCams.length === 0}
            />
            {filteredCameras.length === 0 && (
              <div className={classes.emptyDiv}>
                <EmptyItems
                  variant="small"
                  mode="liveView"
                  noCamTextClassName={clsx(mobile && classes.noCamText)}
                />
              </div>
            )}
            {filteredCameras.length > 0 && (
              <FormControl className={classes.camListDiv}>
                <RadioGroup
                  value={addedCam}
                  onChange={(e) => setAddedCam(e.target.value)}
                >
                  {_.chain(cameraList?.deviceListInfo)
                    .filter(
                      (cam) =>
                        !_.chain(cameras)
                          .map((c) => c?.psn)
                          .includes(cam.device.psn)
                          .value()
                    )
                    .filter((cam) =>
                      _.includes(
                        _.map(filteredCameras, (c) => c?.device.psn),
                        cam.device.psn
                      )
                    )
                    .map((cam) => (
                      <div className={classes.camListItem} key={cam.device.psn}>
                        <RadioButton
                          disabled={cam.device.active === "off"}
                          value={cam.device.psn}
                          label={
                            <Typography
                              className={classes.camName}
                              category="Default"
                              variant="Body"
                            >
                              {cam.device.dev_name}
                            </Typography>
                          }
                        />
                        <Typography
                          className={classes.modelName}
                          category="Default"
                          variant="Small"
                          htmlColor={LightColors.primary["2"]}
                        >
                          {cam.device.model}
                        </Typography>
                      </div>
                    ))
                    .value()}
                </RadioGroup>
              </FormControl>
            )}
          </div>
          <div className={classes.drawerBtnDiv}>
            <div>
              <Button
                variant="outlined"
                color="primary"
                className={classes.cancelBtn}
                onClick={() => {
                  setOpenCameraMenu(false);
                  setSearchKey("");
                }}
              >
                {t("Cancel")}
              </Button>
              <Button
                disabled={addedCam === undefined}
                variant="contained"
                color="primary"
                onClick={() => {
                  const cam = _.find(
                    cameraList?.deviceListInfo,
                    (c) => c.device.psn === addedCam
                  );
                  console.log("add", viewIndx, cam, addedCam);
                  if (viewIndx !== undefined && cam) {
                    updateCenter.current = true;
                    setSelectedPSN(cam.device.psn);
                    setCameras((c) =>
                      update(c, { [viewIndx]: () => cam.device })
                    );
                    setViewIndx(undefined);
                    setOpenCameraMenu(false);
                    setAddedCam(undefined);
                  }
                }}
              >
                {t("Add")}
              </Button>
            </div>
          </div>
        </div>
      </Drawer>
      {/* mantis - 10521, free계정으로 라이브뷰 10분넘게 재생시도시 출력되는 모달 (Leehj)*/}
      <LiveViewExceedModal
        open={openLimitLiveview}
        onClose={() => setOpenLimitLiveview(false)}
        onClickPositive={() => {
          setOpenPricing(true);
          setOpenLimitLiveview(false);
        }}
        onClickNegative={() => {
          setOpenLimitLiveview(false);
        }}
      />
      {/* mantis - 10521, 라이브뷰 재생 모달에서 'Go to Fleet Plan'버튼 누르면 오픈되는 모달 (Leehj)*/}
      <PricingModal open={openPricing} onClose={() => setOpenPricing(false)} />
      {/* <Modal
        open={openLimitLiveview}
        close
        onClose={() => setOpenLimitLiveview(false)}
        onClickPositive={() => {
          setOpenLimitLiveview(false);
        }}
        heading={"  "}
        titleClassName={classes.modalTitle}
        content={t("Exceeded your Live_")}
        RButton={t("OK")}
      /> */}
      <Modal
        open={openNoMicPermModal}
        headingIcon={<ErrorIcon htmlColor={LightColors.secondary["11"]} />}
        heading={t("Microphone blocked")}
        content={
          <>
            <Typography category="Default" variant="Body">
              {t("Enable microphone access_")}
            </Typography>
            <br />
            <br />
            <Typography
              category="Default"
              variant="Small"
              htmlColor={LightColors.primary["3"]}
            >
              * {t("You may need to_")}
            </Typography>
          </>
        }
        close
        onClose={() => setOpenNoMicPermModal(false)}
        onClickPositive={() => setOpenNoMicPermModal(false)}
        RButton={t("OK")}
      />
      <Modal
        open={openNoMicPermIOSModal}
        heading={t("Want to use a Voice call?")}
        content={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Typography category="Default" variant="Body">
              {t("To use a voice call_")}
            </Typography>
            <img
              src="/images/ios-mic-perm.png"
              style={{ width: 270, paddingTop: 16, paddingBottom: 16 }}
              alt="No mic permission"
            />
          </div>
        }
        close
        onClose={() => setOpenNoMicPermIOSModal(false)}
        onClickPositive={() => setOpenNoMicPermIOSModal(false)}
        contentClassName={classes.iosModalContent}
        RButton={t("OK")}
      />
    </div>
  );
};
